import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/electric/machine/user-manager/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/electric/machine/user-manager/info',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/electric/machine/user-manager/logout',
    method: 'post'
  })
}
